module.exports = __webpack_public_path__ + "static/media/ktm_focus_finger.0e3524c7.gif";